import BasicRouterView from "../../../components/BasicRouterView.vue";

const grupoProdutosRoutes = {
  path: "gpd",
  redirect: { name: "salvos" },
  meta: {
    label: "Grupo Produtos",
    icon: "inventory",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "grupo-produto/grupo-produtos-upload",
      name: "grupo-produtos-upload",
      meta: {
        label: "UPLOAD ARQUIVO",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../grupoProdutos/views/UploadArquivos.vue"
        ),
    },
    {
      path: "grupo-produto/grupo-produtos-listar",
      name: "grupo-produtos-listar",
      meta: {
        label: "Lista de Grupos",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../grupoProdutos/views/ListarGrupoPrincipal.vue"
        ),
    },
    {
      path: "grupo-produto/grupo-produtos-adicionar/:id",
      name: "grupo-produtos-adicionar",
      meta: {
        label: "Lista de Grupos",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../grupoProdutos/views/AdicionarProdutoGrupo.vue"
        ),
    },
    {
      path: "grupo-produto/grupo-produtos-regras/:id",
      name: "grupo-produtos-regras",
      meta: {
        label: "Lista de Grupos",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../grupoProdutos/views/DefinirRegrasUnidade.vue"
        ),
    },
    {
      path: "grupo-produto/grupo-produtos-centro/:id",
      name: "grupo-produtos-centro",
      meta: {
        label: "Lista de Grupos",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../grupoProdutos/views/DefinirRegrasCentro.vue"
        ),
    },
    {
      path: "grupo-produto/grupo-produtos-processo/:id",
      name: "grupo-produtos-processo",
      meta: {
        label: "Lista de Grupos",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../grupoProdutos/views/DefinirRegrasProcessos.vue"
        ),
    },
    {
      path: "grupo-produto/grupo-produtos-pessoas/:id",
      name: "grupo-produtos-pessoas",
      meta: {
        label: "Lista de Grupos",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../grupoProdutos/views/DefinirRegrasPessoas.vue"
        ),
    },
    {
      path: "grupo-produto/grupo-produtos-list-regras",
      name: "grupo-produtos-list-regras",
      meta: {
        label: "Regras",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../grupoProdutos/views/ListarRegras.vue"
        ),
    },
  ],
};

export default grupoProdutosRoutes;
